"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfContentExporter = void 0;
var map_creator_1 = require("../../base-utils/map-creator");
var range_permissions_1 = require("../../core/model/range-permissions");
var RtfContentExporter = (function () {
    function RtfContentExporter() {
    }
    RtfContentExporter.createPredefinedUserGroups = function () {
        return new map_creator_1.MapCreator()
            .add(0xFFFA, range_permissions_1.RangePermission.Current_GROUP_NAME)
            .add(0xFFFB, range_permissions_1.RangePermission.Editors_GROUP_NAME)
            .add(0xFFFC, range_permissions_1.RangePermission.Owners_GROUP_NAME)
            .add(0xFFFD, range_permissions_1.RangePermission.Contributors_GROUP_NAME)
            .add(0xFFFE, range_permissions_1.RangePermission.Administrators_GROUP_NAME)
            .add(0xFFFF, range_permissions_1.RangePermission.Everyone_GROUP_NAME)
            .get();
    };
    RtfContentExporter.predefinedUserGroups = RtfContentExporter.createPredefinedUserGroups();
    return RtfContentExporter;
}());
exports.RtfContentExporter = RtfContentExporter;
